/**
 * Created by h3 on 2017-09-19.
 */

export class RocketWinPresentationEvent {
    public static readonly BIG_WIN_PRESENTATIONS_STOPPED:string = "rocketWinPresentationEvent_bigWinPresentationsStopped";
}